import {
  ModalProps,
  FormProps,
  Modal,
  Form,
  Input,
  DatePicker,
  Select,
  useSelect,
} from '@pankod/refine-antd'
import locale from 'antd/lib/locale/id_ID'
import React from 'react'

import { PROGRAM_STATE } from '@resources/lms-management/program/types'

type CreateProgramModalFormProps = {
  createModalProps: ModalProps
  createFormProps: FormProps
  onSubmit: () => Promise<any>
  onClose: () => void
  LMSRole: string
}

const CreateProgramModalForm = ({
  createFormProps,
  createModalProps,
  onSubmit,
  onClose,
  LMSRole,
}: CreateProgramModalFormProps) => {
  const { selectProps } = useSelect({
    resource: 'entities',
    filters: [{ field: 'pageSize', operator: 'eq', value: -1 }],
    optionLabel: 'name',
    optionValue: 'id',
    queryOptions: {
      enabled: !!createModalProps.visible && LMSRole === 'admin-entitas',
    },
    defaultValueQueryOptions: {
      enabled: false,
    },
  })
  const { selectProps: tagSelectProps } = useSelect({
    resource: 'program-tags',
    dataProviderName: 'lms',
    filters: [{ field: 'pageSize', operator: 'eq', value: -1 }],
    optionLabel: 'name',
    optionValue: 'id',
    queryOptions: {
      enabled: !!createModalProps.visible,
    },
    defaultValueQueryOptions: {
      enabled: false,
    },
  })
  return (
    <Modal
      {...createModalProps}
      title="Buat Program Baru"
      okButtonProps={{
        onClick: async () => {
          const data = await onSubmit()
          createFormProps.onFinish?.(data)
        },
      }}
      onCancel={() => {
        onClose()
        createFormProps.form?.resetFields()
      }}
      okText="Buat Program"
      cancelText="Batal"
    >
      <Form
        {...createFormProps}
        layout="vertical"
        validateMessages={{ required: '${label} harus diisi.' }}
      >
        <Form.Item
          label="Nama"
          name="name"
          required
          rules={[{ required: true }]}
        >
          <Input autoComplete="off" />
        </Form.Item>
        <Form.Item
          label="Periode Program"
          name="periode"
          rules={[{ required: true }]}
        >
          <DatePicker.RangePicker
            format="DD MMM YYYY"
            locale={locale.DatePicker}
          />
        </Form.Item>
        <Form.Item label="Rentang Pendaftaran" name="periodePendaftaran">
          <DatePicker.RangePicker
            format="DD MMM YYYY"
            locale={locale.DatePicker}
          />
        </Form.Item>
        {LMSRole === 'admin-entitas' && (
          <Form.Item
            label="Entitas"
            name="entityId"
            rules={[{ required: true }]}
          >
            <Select
              {...selectProps}
              onSearch={() => {}}
              filterOption={(input, option) =>
                (option!.label as unknown as string)
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            />
          </Form.Item>
        )}
        <Form.Item label="Tag" name="tagIds">
          <Select
            mode="multiple"
            {...tagSelectProps}
            onSearch={() => {}}
            filterOption={(input, option) =>
              (option!.label as unknown as string)
                .toLowerCase()
                .includes(input.toLowerCase())
            }
          />
        </Form.Item>
        <Form.Item name="status" hidden>
          <Input value={PROGRAM_STATE.PREPARATION} />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default CreateProgramModalForm
